import ContactForm from "./contactForm";

interface ContactAreaOneProps {
  className?: string;
}

const ContactAreaOne = ({ className }: ContactAreaOneProps) => {
  return (
    <div>
      </div>
    // <div
    //   className={`contact-area bg-f3f3f3 border-top border-bottom ptb-120 ${className || ""}`}
    // >
    //   <div
    //     className="container"
       
    //   >
    //     <div className="section-title text-center">
    //       <h2 className="fw-semibold mx-auto mb-0 text-uppercase fs-3">
    //         Have any question?
    //       </h2>
    //       <p className="fs-6">
    //         Your email address will not be published. Required fields are marked *
    //       </p>
    //     </div>
 
    //     <ContactForm />
    //   </div>
    // </div>
  );
};

export default ContactAreaOne;
